import type { TFunction } from 'i18next'

export const stayDayOptions = (t: TFunction) => {
  return [
    {
      id: 1,
      name: '1' + t('top.modal_search.week'),
      value: '7',
    },
    {
      id: 2,
      name: '2' + t('top.modal_search.week'),
      value: '14',
    },
    {
      id: 3,
      name: '3' + t('top.modal_search.week'),
      value: '21',
    },
    {
      id: 4,
      name: '1' + t('top.modal_search.month_number_from'),
      value: '27',
    },
  ]
}

export const regionOptions = (t: TFunction) => {
  return [
    {
      id: 0,
      name: t('top.modal_search.search_region.hokkaido'),
      value: '北海道',
    },
    {
      id: 1,
      name: t('top.modal_search.search_region.tohoku'),
      value: '東北',
    },
    {
      id: 2,
      name: t('top.modal_search.search_region.hokuriku_koshinetsu'),
      value: '北陸・甲信越',
    },
    {
      id: 3,
      name: t('top.modal_search.search_region.kanto'),
      value: '関東',
    },
    {
      id: 4,
      name: t('top.modal_search.search_region.tokai_kinki'),
      value: '東海・近畿',
    },
    {
      id: 5,
      name: t('top.modal_search.search_region.chugoku_shikoku'),
      value: '中国・四国',
    },
    {
      id: 6,
      name: t('top.modal_search.search_region.kyushu_okinawa'),
      value: '九州・沖縄',
    },
  ]
}

export const acceptClassOptions = (t: TFunction) => {
  return [
    {
      id: 0,
      name: t('top.modal_search.class.no_attendance'),
      value: 'no_enrollment',
    },
    {
      id: 1,
      name: t('top.modal_search.class.0_year_old_class'),
      value: t('top.modal_search.value.0_year_old_class'),
    },
    {
      id: 2,
      name: t('top.modal_search.class.1_year_old_class'),
      value: t('top.modal_search.value.1_year_old_class'),
    },
    {
      id: 3,
      name: t('top.modal_search.class.2_years_old_class'),
      value: t('top.modal_search.value.2_years_old_class'),
    },
    {
      id: 4,
      name: t('top.modal_search.class.3_years_old_class'),
      value: t('top.modal_search.value.3_years_old_class'),
    },
    {
      id: 5,
      name: t('top.modal_search.class.4_years_old_class'),
      value: t('top.modal_search.value.4_years_old_class'),
    },
    {
      id: 6,
      name: t('top.modal_search.class.5_years_old_class'),
      value: t('top.modal_search.value.5_years_old_class'),
    },
  ]
}

export type KeyDataSearch =
  | 'maximum_number_of_adults'
  | 'maximum_number_of_children'
  | 'no_car'
  | 'stay_day'
  | 'plan_month'
  | 'accept_class'
  | 'category_name'

export type ChildrenType = {
  id: number
  name: string
  value: string
}

export type DataSearchType = {
  maximum_number_of_adults: number
  maximum_number_of_children: number
  accept_class: ChildrenType[]
  no_car: string
  stay_day: string[]
  plan_month: string[]
  text_search: string
  category_name: string[]
}

export const DATA_SEARCH_INIT: DataSearchType = {
  maximum_number_of_adults: 0,
  maximum_number_of_children: 0,
  accept_class: [],
  no_car: '',
  stay_day: [],
  plan_month: [],
  text_search: '',
  category_name: [],
}
